module.exports = __webpack_public_path__ + "static/media/Walter_Portrait.4af3492c.png";